export default __webpack_public_path__ + "static/media/close.3ddabf7a.svg";